export default __webpack_public_path__ + "static/media/sleep-soundscape.71bbdc4c.jpeg";